
import { createRoot } from 'react-dom/client';

import './style.scss';
import Style from './Style';
import Layout from './Layout';
import useWPAjax from './hooks/useWPAjax';

// Block Directory
document.addEventListener('DOMContentLoaded', () => {
	const googlePhotosAllEles = document.querySelectorAll('.wp-block-bpgpb-google-photos');
	googlePhotosAllEles.forEach(googlePhotosEle => {
		const attributes = JSON.parse(googlePhotosEle.dataset.attributes);
		const info = JSON.parse(googlePhotosEle.dataset.info);


		createRoot(googlePhotosEle).render(<>
			<Style attributes={attributes} clientId={attributes.cId} />
			<DirectoryRender attributes={attributes} info={info} />
		</>);

		googlePhotosEle?.removeAttribute('data-attributes');
	});
});

const DirectoryRender = ({ attributes, info }) => {
	const { photosType } = attributes;
	const { isLoading, data: token, refetch: fetchData } = useWPAjax('bpgpb_retrieve_access_token', { nonce: info?.nonce });

	if (!token?.access_token || !photosType) {
		return <></>
	}

	return <div className='BPGPBBlockDirectory'>
		<Layout attributes={attributes} token={token} />
	</div>
}